import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { App1Module } from './app/app1.module';
import { environment } from './environments/environment';

//WE ARE USING CONFIG FILES
// if (environment.production) {
//   enableProdMode();
// }

platformBrowserDynamic()
  .bootstrapModule(App1Module)
  .catch((err) => console.error(err));
